import { useState, useCallback } from 'react'
import { useVocdoni } from '../contexts/vocdoni-context'
import { AccountData, VocdoniSDKClient } from '@vocdoni/sdk'

export function useVocdoniAccount() {
  const { client } = useVocdoni()
  const [account, setAccount] = useState<AccountData | null>(null)
  const [isCreating, setIsCreating] = useState(false)
  const [error, setError] = useState<string | null>(null)

  const createAccount = useCallback(async () => {
    if (!client) {
      setError('Vocdoni client not initialized')
      return
    }

    try {
      setIsCreating(true)
      setError(null)

      const newAccount = await (client as VocdoniSDKClient).createAccount()

      if (newAccount && newAccount.balance <= 0) {
        await client.collectFaucetTokens()
        const updatedAccount = await client.fetchAccount()
        setAccount(updatedAccount)
      } else {
        setAccount(newAccount)
      }
    } catch (err) {
      console.error('Failed to create Vocdoni account:', err)
      setError('Failed to create Vocdoni account')
    } finally {
      setIsCreating(false)
    }
  }, [client])

  return { account, isCreating, error, createAccount }
} 